export type CredentialStatus = {
  id: string;
  type: string;
};
